"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function NewUsed() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="new-vs-used" data-nav="light" className="bg-background text-foreground border-b border-border py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
        {/* Section Header */}
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.16, 1, 0.3, 1]
      }} className="mb-12 border-b border-border pb-8">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
            <div className="max-w-3xl">
              <span className="font-mono text-sm tracking-wider uppercase text-muted-foreground font-medium block mb-2">
                Machinery Classification & Selection
              </span>
              <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold uppercase tracking-tight text-foreground">
                New vs used equipment
              </h2>
              <p className="mt-3 font-sans text-base sm:text-lg text-muted-foreground leading-relaxed">
                Neither option is automatically better. The right choice depends on your budget, how quickly you need the machine, how often you expect to use it and how much certainty you want about its history.
              </p>
            </div>

            <div className="flex flex-wrap items-center gap-3">
              <Button asChild variant="outline" className="rounded-none border-foreground text-foreground hover:bg-foreground hover:text-background font-serif uppercase tracking-wider text-sm px-5 py-2.5 h-auto transition-[color,background-color,border-color]">
                <Link to="/UsedMechanicalBullsPage">
                  Used Bull Inventory
                </Link>
              </Button>
              <Button asChild className="rounded-none bg-primary text-primary-foreground hover:bg-primary/90 font-serif uppercase tracking-wider text-sm px-5 py-2.5 h-auto transition-[color,background-color,border-color]">
                <Link to="/NewMechanicalBullsPage">
                  New Bull Catalog
                </Link>
              </Button>
            </div>
          </div>
        </motion.div>

        {/* Buyer Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* New Mechanical Bulls Card */}
          <motion.div initial={shouldReduceMotion ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.16, 1, 0.3, 1]
        }} className="border border-border bg-card p-6 sm:p-8 flex flex-col justify-between">
            <div>
              <h3 className="font-serif text-2xl sm:text-3xl font-bold uppercase tracking-wide text-foreground mb-4">
                New Mechanical Bulls
              </h3>
              <p className="font-sans text-base text-muted-foreground leading-relaxed mb-8">
                New equipment gives the buyer a known starting condition. Compare the exact package, controller, included equipment, product information and whatever warranty or support genuinely applies to the individual model.
              </p>
            </div>
            <div>
              <Button asChild className="rounded-none bg-primary text-primary-foreground hover:bg-primary/90 font-serif uppercase tracking-wider text-sm px-6 py-3 h-auto w-full sm:w-auto transition-[color,background-color,border-color]">
                <Link to="/NewMechanicalBullsPage">
                  VIEW NEW BULLS
                </Link>
              </Button>
            </div>
          </motion.div>

          {/* Used Mechanical Bulls Card */}
          <motion.div initial={shouldReduceMotion ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: 0.06,
          ease: [0.16, 1, 0.3, 1]
        }} className="border border-border bg-card p-6 sm:p-8 flex flex-col justify-between">
            <div>
              <h3 className="font-serif text-2xl sm:text-3xl font-bold uppercase tracking-wide text-foreground mb-4">
                Used Mechanical Bulls
              </h3>
              <p className="font-sans text-base text-muted-foreground leading-relaxed mb-8">
                Used equipment can reduce the initial purchase cost, but buyers should compare the exact machine's condition, controller, inflatable, included equipment, known history and parts availability.
              </p>
            </div>
            <div>
              <Button asChild variant="outline" className="rounded-none border-foreground text-foreground hover:bg-foreground hover:text-background font-serif uppercase tracking-wider text-sm px-6 py-3 h-auto w-full sm:w-auto transition-[color,background-color,border-color]">
                <Link to="/UsedMechanicalBullsPage">
                  VIEW USED BULLS
                </Link>
              </Button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}